<template>
  <div class="truncate">
    <h5>{{ presentation.name }}</h5>
    <span class="presentation-info">
      <span class="min-w-max">
        <aha-icon-container>
          <aha-icon
            name="slides"
            width="10"
            height="10"
            viewBox="0 0 12 12"
            v-tooltip="tooltipNumOfSlides"
          />
        </aha-icon-container>
        <span class="text-xs text-base-80">
          {{ presentation.slideCount }}
        </span>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    presentation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    tooltipNumOfSlides() {
      return this.$i18nPresenter.t('Number of slides')
    },
  },
}
</script>

<style lang="scss" scoped>
.presentation-info {
  @apply flex flex-wrap items-center mt-1 font-normal leading-6;
}
</style>
